import React from 'react'
import { useQuery } from 'urql'

import { BasicInvoiceDocument, BasicInvoiceQuery } from '@/gql/graphql'

import { Invoice } from './Invoice'
import { InvoiceProps } from './types'
import { groupItemsByVenue } from './utils'

interface Props {
  orderId: string
}

export const processData = (data?: BasicInvoiceQuery): InvoiceProps => {
  const invoice = data?.invoice
  const items = invoice?.lineItems || []
  const groupedItems = groupItemsByVenue(items)
  const totalInCents = invoice?.totalInCents || 0
  const totalTaxInCents = invoice?.totalTaxInCents || 0

  return {
    invoice,
    user: invoice?.user,
    items,
    groupedItems,
    totalInCents,
    totalTaxInCents,
  }
}

export const BasicInvoice = ({ orderId }: Props) => {
  const [{ data, fetching, error }] = useQuery({
    query: BasicInvoiceDocument,
    variables: { orderId },
  })

  const invoiceData = processData(data)

  return <Invoice fetching={fetching} error={error} {...invoiceData} />
}
